<template>
  <main id="main-content" class="registration-closed">
    <div class="homeEnds">
      <div class="plan_box">
        <div class="close_box">
          <div class="box">
            <div class="logo_box">
              <h1>
                推動餐飲服務業優質成長暨國際推廣計畫
              </h1>
            </div>
            <div class="text_box">
              <p class="title"> <img src="@/assets/registration-closed/icon1.svg" alt="">本活動報名已截止 </p>
              <p> 感謝您的關注與支持，本活動已截止報名，不再受理報名申請。相關活動資訊及後續消息，敬請持續關注本網站公告 </p>
              <div v-if="hasOngoingRating" class="reviewer-entry">
                <router-link :to="{ name: 'LoginForReviewer' }" tag="button" type="button">委員登入</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>


<script>
export default {
  name: "RegistrationClosed",
  props: {
    hasOngoingRating: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.registration-closed {
    font-family: Arial, 'Noto Sans TC', sans-serif;
    line-height: normal;
    color: #1f2937;
}

.homeEnds {
    min-height: 100vh;
}

.homeEnds .plan_box {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #fff7f0;
    background-image: url(../assets/registration-closed/imgBg_1.png), url(../assets/registration-closed/imgBg_2.png);
    background-repeat: no-repeat;
    background-position: left center, right center;
    background-size: contain;
}

.reviewer-entry {
    margin-top: 24px;
    text-align: center;
}

.reviewer-entry button {
    min-height: 44px;
    padding: 10px 28px;
    border: 1px solid #ff6200;
    border-radius: 8px;
    background-color: #ff6200;
    color: #fff;
    font: inherit;
    font-weight: 600;
}

.reviewer-entry button:hover {
    background-color: #c94d00;
    border-color: #c94d00;
}

.reviewer-entry button:focus-visible {
    outline: 2px solid #712205;
    outline-offset: 4px;
}

.homeEnds .plan_box .close_box {
    padding: 20px;
}

.homeEnds .plan_box .close_box .box {
    background-color: #ffffffdc;
    border-radius: 30px;
    padding: 25px;
    box-shadow: 2px 2px 12px #00000030;
    max-width: 670px;
}

.homeEnds .plan_box .close_box .box .logo_box {
    border-bottom: 1px dotted #353535;
    padding: 20px 10px;
}

.homeEnds .plan_box .close_box .box .logo_box img {
    width: 100%;
}

.homeEnds .plan_box .close_box .box .logo_box h1 {
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1.12;
    color: #141b2f;
    margin: 0;
    letter-spacing: 2px;
    margin-top: 10px;
}

.homeEnds .plan_box .close_box .box .text_box {
    padding: 20px 0px;
}

.homeEnds .plan_box .close_box .box .text_box p {
    margin: 0;
    font-size: 1.2rem;
    color: #353535;
    font-weight: 500;
}

.homeEnds .plan_box .close_box .box .text_box p.title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #ff6200;
    margin-bottom: 15px;
    display: inline-block;

    border: 1px solid #ff6200;
    padding: 5px 15px;
    padding-bottom: 8px;
    border-radius: 10px;
    letter-spacing: 1px;
}

.homeEnds .plan_box .close_box .box .text_box p.title img {
    display: inline-block;
    vertical-align: baseline;
    width: 30px;
    margin-right: 5px;
    transform: translateY(5px);
}

@media (max-width: 767.98px) {

    .homeEnds .plan_box .close_box {
        padding: 10px;
    }
}

@media (max-width: 575.98px) {

    .homeEnds .plan_box .close_box .box {
        padding: 15px;
    }
}
</style>
